<nav class="dot-navigation">
  <ul>
    <li *ngFor="let section of sections" [class.active]="activeSection === section.id"
      (mouseenter)="hoveredSection = section.id" (mouseleave)="hoveredSection = null">
      <div class="dot-wrapper" (click)="scrollToSection(section.id)">
        <span class="dot-circle"></span>
        <span class="dot-label" *ngIf="hoveredSection === section.id">{{ section.label }}</span>
      </div>
    </li>
  </ul>
</nav>

<!-- ----------------HERO SECTION----------------- -->
<div class="hero-section-bg" id="heroObserverTarget">
  <section id="hero" class="hero-section container-fluid">
    <div class="glass-panel-container">
      <div class="container-fluid px-0">
        <div class="row align-items-center h-100">

          <!-- Left Content -->
          <div class="col-lg-6 col-md-12 content-column">
            <h1 class="hero-heading mb-2">
              AI-Based Software Development Company
            </h1>
            <p class="hero-subheading mb-4">
              in Bangalore & USA
            </p>

            <div class="mb-5 action-buttons">
              <button class="btn case-study-btn me-3" (click)="goToCaseStudies()">
                Case Studies
              </button>
              <button class="btn hire-btn hire" (click)="openContactModal()">
                Hire Us
              </button>
            </div>

            <!-- Badges -->
            <div class="row badges-row gx-3 gy-3 mb-4">
              <div class="col-3 col-sm-3">
                <div class="badge-item">
                  <img src="../../../assets/home/banner-icons/iso-certified.webp" alt="ISO Certified" loading="lazy"
                    decoding="async">
                </div>
              </div>
              <div class="col-3 col-sm-3">
                <div class="badge-item">
                  <img src="../../../assets/home/banner-icons/great-place-to-work.webp" alt="Great Place to Work"
                    loading="lazy" decoding="async">
                </div>
              </div>
              <div class="col-3 col-sm-3">
                <div class="badge-item">
                  <img src="../../../assets/home/banner-icons/soc-2.webp" alt="SOC 2" loading="lazy" decoding="async">
                </div>
              </div>
              <!-- <div class="col-3 col-sm-3">
                <div class="badge-item">
                  <img src="../../../assets/home/banner-icons/goodfirms.webp" alt="GoodFirms" loading="lazy"
                    decoding="async">
                </div>
              </div> -->
            </div>
          </div>

          <!-- Right Image -->
          <div class="col-lg-6 col-md-12 text-center image-column">
            <div class="hero-image-wrapper">
              <video #heroVideo src="../../../assets/home/hero-section/heroVideo.webm" class="img-fluid hero-image" autoplay loop
                muted playsinline disablePictureInPicture oncontextmenu="return false;" loading="eager"
                fetchpriority="high">
              </video>
            </div>
          </div>

        </div>
      </div>
    </div>
  </section>
</div>

<!----------------- STATS AND CLIENTS SECTION ---------------->
<div class="stats-and-clients-bg" id="clientsObserverTarget">
  <section id="clients" class="stats-section container">
    <div class="partners-clients-card">

      <div class="long-standing-wrapper">
        <h4 class="ls-title">Long-Standing Partnerships <span class="arrow">▶</span></h4>

        <div class="ls-partners">
          <div class="ls-item">
            <img src="../../../assets/home/clients/NFP.svg" alt="NFP" loading="lazy">
            <span class="years">7 Years</span>
          </div>
          <div class="ls-item">
            <img src="../../../assets/home/clients/Diligencia.svg" alt="Diligencia" loading="lazy">
            <span class="years">7 Years</span>
          </div>
          <div class="ls-item">
            <img src="../../../assets/home/clients/LG.svg" alt="LG" loading="lazy">
            <span class="years">4 Years</span>
          </div>
        </div>
      </div>
      <div class="dotted-separator"></div>
      <div class="scrolling-clients-wrapper">

        <div class="marquee">
          <div class="marquee-track">
            <ng-container *ngFor="let i of [1,2,3,4,5,6]">
              <img src="../../../assets/home/clients/Omnisite.svg" alt="OmniSite" loading="lazy">
              <img src="../../../assets/home/clients/NFP.svg" alt="NFP" loading="lazy">
              <img src="../../../assets/home/clients/Emids.svg" alt="EMIDS" loading="lazy">
              <img src="../../../assets/home/clients/Innova.svg" alt="Innova" loading="lazy">
              <img src="../../../assets/home/clients/LG.svg" alt="LG" loading="lazy">
              <img src="../../../assets/home/clients/Diligencia.svg" alt="Diligencia" loading="lazy">
            </ng-container>
          </div>
        </div>

      </div>
    </div>

  </section>
</div>

<!-- Clients Testimonials Section (Lazy Loaded) -->
<div id="testimonialsObserverTarget" style="min-height: 600px;">
  <ng-container *ngIf="shouldLoadSection('testimonials')">
    <app-clients-testimonal id="testimonials"></app-clients-testimonal>
  </ng-container>
</div>

<!-- ---------MILESTONES SECTION-------- -->
<div class="milestones-bg" id="milestonesObserverTarget">
  <section id="milestones" class="milestones-section container">
    <h2>Measurable Success</h2>
    <div class="milestones-glass-panel">
      <!-- Video Element with ID for specific observation -->
      <video #milestoneVideo src="assets/home/milestones/milestones.webm" class="milestones-image" muted playsinline
        disablePictureInPicture oncontextmenu="return false;" preload="none">
      </video>
    </div>
  </section>
</div>

<!-- ---------------INDUSTRIES SECTION-------------------- -->
<section id="industries" class="industries-section container-fluid py-5">
  <div class="container">
    <div class="section-header text-center mx-auto mb-5">
      <h2>Industry Expertise Tailored to Your Business Needs</h2>
      <p class="section-subtitle">
        Our crossindustry experience spans critical verticals, leveraging AI, automation, <br>and nextgen software to
        drive
        digital transformation.
      </p>
    </div>

    <ng-container *ngIf="industriesVisible">
      <div class="row align-items-center justify-content-center">

        <!-- Image Cards Column -->
        <div class="col-lg-6 mb-4 mb-lg-0">
          <div class="image-cards-container">
            <ng-container *ngFor="let item of templateItems; let i = index">

              <div *ngIf="!isPlaceholder(item)" class="industry-image-card" [class.hovered]="hoveredIndustryIndex === i"
                (mouseenter)="pauseIndustrySlider();setHoveredIndustry(i)" (mouseleave)="resumeIndustrySlider(); clearHoveredIndustry()"
                (click)="navigateTo(item.route)" [@industryImageAnim]="{
                  value: ':enter',
                  params: { 
                    startOffset: i === 0 ? '0%' : '-105%', 
                    delay: i * 700,
                    zIndex: 10 - i 
                  }
                }">
                <div class="image-overlay"></div>
                <img [src]="item.imageSrc" [alt]="item.title" loading="lazy">
              </div>

              <div *ngIf="isPlaceholder(item)" class="industry-image-card is-placeholder"></div>
            </ng-container>
          </div>
        </div>

        <!-- Text Cards Column -->
        <div class="col-lg-6">
          <div class="text-cards-container">
            <ng-container *ngFor="let item of templateItems; let i = index">

              <div *ngIf="!isPlaceholder(item)" class="industry-text-card" [class.hovered]="hoveredIndustryIndex === i"
                (mouseenter)="pauseIndustrySlider(); setHoveredIndustry(i)" (mouseleave)="resumeIndustrySlider(); clearHoveredIndustry()"
                (click)="navigateTo(item.route)" [@industryTextAnim]="{
                  value: ':enter',
                  params: { 
                    startOffset: i === 0 ? '20px' : '-105%', 
                    delay: (i * 700) + 200,
                    zIndex: 10 - i
                  }
                }">
                <div class="card-icon">
                  <img [src]="item.iconSrc" [alt]="item.title + ' Icon'" loading="lazy">
                </div>
                <div class="card-content">
                  <h5 class="card-title">{{ item.title }}</h5>
                  <p class="card-text">{{ item.description }}</p>
                </div>
              </div>

              <div *ngIf="isPlaceholder(item)" class="industry-text-card is-placeholder"></div>
            </ng-container>
          </div>
        </div>

      </div>
    </ng-container>

    <div *ngIf="!industriesVisible" style="height: 450px; width: 100%;"></div>
    <div class="pagination-indicators">
      <div *ngFor="let page of paginatedIndustries; let i = index" class="indicator"
        [ngClass]="{'active': i === activeSlideIndex}" (click)="selectSlide(i)">
      </div>
    </div>
  </div>
</section>

<!-- Technologies Section (Lazy Loaded) -->
<div id="technologyObserverTarget" style="min-height: 500px;">
  <ng-container *ngIf="shouldLoadSection('technology')">
    <app-suite-technologies id="technology"></app-suite-technologies>
  </ng-container>
</div>

<!-- ABOUT US SECTION -->
<section id="about" class="solutions-section">
  <div class="container">
    <div class="section-header text-center mx-auto">
      <h2>Your Trusted Enterprise AI & Software Development Partner <br>in Bangalore & USA</h2>
    </div>

    <!-- Top Content Row -->
    <div class="row">
      <div class="col-lg-5">
        <div class="solutions-image-container">
          <!-- Removed image-overlay div, kept layout classes -->
          <div class="solution-image-card image-one">
            <img src="../../../assets/home/about-us/about-us-img1.png" alt="Team collaborating on computer"
              loading="lazy">
          </div>
          <div class="solution-image-card image-two">
            <img src="../../../assets/home/about-us/about-us-img2.png" alt="Two colleagues looking at a laptop"
              loading="lazy">
          </div>
        </div>
      </div>
      <div class="col-lg-7">
        <div class="solutions-content">
          <h3 class="content-title">Why Choose Kalpita as Your AI Software Development Partner? </h3>
          <p class="content-text">
            At Kalpita Technologies, we go beyond coding, we engineer transformation.
            As a leading AI-driven software development company in Bangalore and the USA, we
            help enterprises accelerate growth with custom software solutions across industries.
          </p>
          <div class="features-list row">
            <ul class="col-md-12">
              <li><img src="../../../assets/home/arrow-indicator.svg" alt="Indicator" loading="lazy">Near‑shore and
                near‑heart delivery
                model personalized for U.S. & India </li>
              <li><img src="../../../assets/home/arrow-indicator.svg" alt="Indicator" loading="lazy">Engineers deeply
                embedded in
                client culture and business goals </li>
              <li><img src="../../../assets/home/arrow-indicator.svg" alt="Indicator" loading="lazy">Agile, scalable and
                secure digital
                transformation strategies </li>
              <li><img src="../../../assets/home/arrow-indicator.svg" alt="Indicator" loading="lazy">GEO &
                AEO-optimized, future‑ready
                software architecture </li>
              <li><img src="../../../assets/home/arrow-indicator.svg" alt="Indicator" loading="lazy">Rapid deployment
                delivering proven
                ROI and high impact</li>
              <li><img src="../../../assets/home/arrow-indicator.svg" alt="Indicator" loading="lazy">DevSecOps-first
                approach with security embedded across SDLC</li>
              <li><img src="../../../assets/home/arrow-indicator.svg" alt="Indicator" loading="lazy">AI-driven security
                measures for proactive threat detection & risk mitigation</li>
              <li><img src="../../../assets/home/arrow-indicator.svg" alt="Indicator" loading="lazy">Security-trained
                engineers with proven secure development expertise</li>
              <li><img src="../../../assets/home/arrow-indicator.svg" alt="Indicator" loading="lazy">GDPR-aligned data
                privacy with Privacy by Design, embedding security and privacy from the start</li>
            </ul>
          </div>
          <button class="btn hire-btn hire read-more" (click)="ExploreAboutUs()">
            Explore About Us
          </button>
        </div>
      </div>
    </div>

    <div id="metrics-trigger" class="metrics-wrapper">
      <div *ngIf="metricsVisible" [@metricsAnim] class="row metrics-row gx-4 gy-4">
        <div class="col-lg-4 col-md-6">
          <div class="metric-item" (click)="navigateTo('kalpita-case-studies/aidriven-insurance-application')">
            <h4>30% Higher Efficiency</h4>
            <h5>InsurTech</h5>
            <p>For Smart Insure, we streamlined policy onboarding and customer engagement, boosting operational
              efficiency by 30% and improving conversion rates by 10–15%. The result: faster, more accurate, and
              customer-centric insurance solutions.</p>
          </div>
        </div>
        <div class="col-lg-4 col-md-6">
          <div class="metric-item" (click)="navigateTo('kalpita-case-studies/us-retirement-plan')">
            <h4>50% Faster Reports</h4>
            <h5>FinTech</h5>
            <p>With the US Retirement Plan, we enhanced data accuracy and reduced errors by 30%, while enabling
              financial advisors to generate detailed, customized reports 50% faster. This empowered timely, informed
              decision-making and improved client confidence.</p>
          </div>
        </div>
        <div class="col-lg-4 col-md-6">
          <div class="metric-item" (click)="navigateTo('kalpita-case-studies/unified-system-insurance')">
            <h4>100% Billing Accuracy</h4>
            <h5>InsurTech</h5>
            <p>The Azure-powered automated billing system streamlines billing management with an intuitive interface,
              real-time updates, and notifications, saving time while ensuring 100% accuracy and minimizing human
              errors.</p>
          </div>
        </div>
      </div>

      <div *ngIf="!metricsVisible" style="height: 300px; width: 100%;"></div>

    </div>
  </div>
</section>

<!-- SERVICES SECTION -->
<div class="services-section-bg">
  <section id="services" class="container-fluid py-5">
    <div class="container">
      <div class="section-header text-center mx-auto mb-5">
        <h2>Explore Our Software Development Services</h2>
        <p class="section-subtitle">
          Discover the features that make us a reliable<br>technology partner for you.
        </p>
      </div>

      <ng-container *ngIf="servicesVisible">
        <div class="row align-items-center justify-content-center">

          <!-- Image Cards Column -->
          <div class="col-lg-6 mb-4 mb-lg-0">
            <div class="services-image-cards-container">
              <ng-container *ngFor="let item of templateServiceItems; let i = index">

                <div *ngIf="!isServicePlaceholder(item)" class="service-image-card"
                  [class.hovered]="hoveredServiceIndex === i" (mouseenter)="pauseServiceSlider(); setHoveredService(i)"
                  (mouseleave)="resumeServiceSlider(); clearHoveredService()" (click)="navigateTo(item.route)" [@serviceImageAnim]="{
                    value: ':enter',
                    params: { 
                      startOffset: i === 0 ? '0%' : '-105%', 
                      delay: i * 700,
                      zIndex: 10 - i 
                    }
                  }">
                  <img [src]="item.imageSrc" [alt]="item.title" loading="lazy">
                </div>

                <div *ngIf="isServicePlaceholder(item)" class="service-image-card is-placeholder"></div>
              </ng-container>
            </div>
          </div>

          <!-- Text Cards Column -->
          <div class="col-lg-6">
            <div class="services-text-cards-container">
              <ng-container *ngFor="let item of templateServiceItems; let i = index">

                <div *ngIf="!isServicePlaceholder(item)" class="service-text-card"
                  [class.hovered]="hoveredServiceIndex === i" (mouseenter)="pauseServiceSlider(); setHoveredService(i)"
                  (mouseleave)="resumeServiceSlider(); clearHoveredService()" (click)="navigateTo(item.route)" [@serviceTextAnim]="{
                    value: ':enter',
                    params: { 
                      startOffset: i === 0 ? '20px' : '-105%', 
                      delay: (i * 700) + 200,
                      zIndex: 10 - i
                    }
                  }">
                  <div class="card-icon">
                    <img [src]="item.iconSrc" [alt]="item.title + ' Icon'" loading="lazy">
                  </div>
                  <div class="card-content">
                    <h5 class="card-title">{{ item.title }}</h5>
                    <p class="card-text">{{ item.description }}</p>
                  </div>
                </div>

                <div *ngIf="isServicePlaceholder(item)" class="service-text-card is-placeholder"></div>
              </ng-container>
            </div>
          </div>
        </div>
      </ng-container>

      <div *ngIf="!servicesVisible" style="height: 450px; width: 100%;"></div>
      <div class="pagination-indicators">
        <div *ngFor="let page of paginatedServices; let i = index" class="indicator"
          [ngClass]="{'active': i === activeServiceSlideIndex}" (click)="selectServiceSlide(i)">
        </div>
      </div>
    </div>
  </section>
</div>

<!-- BLOGS/NEWSPAPER/WHITEPAPER (Lazy Loaded) -->
<div id="recentupdatesObserverTarget" style="min-height: 400px;">
  <ng-container *ngIf="shouldLoadSection('recentupdates')">
    <app-recent-updates id="recentupdates"></app-recent-updates>
  </ng-container>
</div>

<!-- GALLERY (Lazy Loaded) -->
<div id="galleryObserverTarget" style="min-height: 400px;">
  <ng-container *ngIf="shouldLoadSection('gallery')">
    <section id="gallery" class="gallery-section py-5">
      <div class="container">
        <div class="heading-tags pb-4">
          <h2 class="heading-two">Experience Kalpita Through Our Video Gallery</h2>
        </div>
        <app-gallery></app-gallery>
      </div>
    </section>
  </ng-container>
</div>